import { mapState, mapMutations } from 'vuex';
import { themesMixin } from '../utils/themes';
export default {
  name: 'ViewOauthConsent',
  mixins: [themesMixin],
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'CustomTheme']),
    loginLogo() {
      const mode = this.themeGetMode();
      return {
        image: this.$store.state.app.themes[mode].logo,
        orientation: this.$store.state.app.themes[mode].orientation
      };
    },
    loginBackground() {
      const mode = this.themeGetMode();
      return this.$store.state.app.themes[mode].background;
    },
    redirect() {
      return `${this.$store.state.app.redirect}&token=${localStorage.getItem('token')}`;
    }
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    getBG() {
      return `background-image: url(${this.loginBackground}); background-size: cover;`;
    },
    redirectFn() {
      // check if redirect is a valid url e.g. not javascript:alert('xss') or data:image/png;base64,i...
      const url = new URL(this.redirect);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        console.error('Invalid redirect URL:', this.redirect);
        this.$snack(this.$i18n_t('Common.invalidRedirect') || 'Invalid redirect URL', 'error');
        this.$router.push('/home');
        return;
      }
      window.location.href = url.toString();
    }
  }
};